import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { createDebug } from '../utils/debugLog'
import { SUPPORTED_LOCALES } from './supportedLocales'
import enProfile from './locales/en/profile.json'
import koProfile from './locales/ko/profile.json'
import enHeader from './locales/en/header.json'
import koHeader from './locales/ko/header.json'
import enLogin from './locales/en/login.json'
import koLogin from './locales/ko/login.json'
import enChat from './locales/en/chat.json'
import koChat from './locales/ko/chat.json'
import enWorkspace from './locales/en/workspace.json'
import koWorkspace from './locales/ko/workspace.json'
import enSettings from './locales/en/settings.json'
import koSettings from './locales/ko/settings.json'
import enCanvas from './locales/en/canvas.json'
import koCanvas from './locales/ko/canvas.json'
import enPages from './locales/en/pages.json'
import koPages from './locales/ko/pages.json'
import enLanding from './locales/en/landing.json'
import koLanding from './locales/ko/landing.json'
import enShared from './locales/en/shared.json'
import koShared from './locales/ko/shared.json'
import enAuth from './locales/en/auth.json'
import koAuth from './locales/ko/auth.json'
import viProfile from './locales/vi/profile.json'
import viHeader from './locales/vi/header.json'
import viLogin from './locales/vi/login.json'
import viChat from './locales/vi/chat.json'
import viWorkspace from './locales/vi/workspace.json'
import viSettings from './locales/vi/settings.json'
import viCanvas from './locales/vi/canvas.json'
import viPages from './locales/vi/pages.json'
import viLanding from './locales/vi/landing.json'
import viShared from './locales/vi/shared.json'
import viAuth from './locales/vi/auth.json'
import zhHantProfile from './locales/zh-Hant/profile.json'
import zhHantHeader from './locales/zh-Hant/header.json'
import zhHantLogin from './locales/zh-Hant/login.json'
import zhHantChat from './locales/zh-Hant/chat.json'
import zhHantWorkspace from './locales/zh-Hant/workspace.json'
import zhHantSettings from './locales/zh-Hant/settings.json'
import zhHantCanvas from './locales/zh-Hant/canvas.json'
import zhHantPages from './locales/zh-Hant/pages.json'
import zhHantLanding from './locales/zh-Hant/landing.json'
import zhHantShared from './locales/zh-Hant/shared.json'
import zhHantAuth from './locales/zh-Hant/auth.json'

const log = createDebug('dw:i18n')

const LOCALE_STORAGE_KEY = 'dw_preferred_locale'

const languageDetector = new LanguageDetector()

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { profile: enProfile, header: enHeader, login: enLogin, chat: enChat, workspace: enWorkspace, settings: enSettings, canvas: enCanvas, pages: enPages, landing: enLanding, shared: enShared, auth: enAuth },
      ko: { profile: koProfile, header: koHeader, login: koLogin, chat: koChat, workspace: koWorkspace, settings: koSettings, canvas: koCanvas, pages: koPages, landing: koLanding, shared: koShared, auth: koAuth },
      vi: { profile: viProfile, header: viHeader, login: viLogin, chat: viChat, workspace: viWorkspace, settings: viSettings, canvas: viCanvas, pages: viPages, landing: viLanding, shared: viShared, auth: viAuth },
      // Quoted: a code carrying a script subtag is not a bare JS identifier.
      'zh-Hant': { profile: zhHantProfile, header: zhHantHeader, login: zhHantLogin, chat: zhHantChat, workspace: zhHantWorkspace, settings: zhHantSettings, canvas: zhHantCanvas, pages: zhHantPages, landing: zhHantLanding, shared: zhHantShared, auth: zhHantAuth },
    },
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: ['profile', 'header', 'login', 'chat', 'workspace', 'settings', 'canvas', 'pages', 'landing', 'shared', 'auth'],
    defaultNS: 'profile',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Pre-auth / boot: synchronous best guess from the user's own last choice
      // (localStorage) then the browser. Once authenticated, LocaleSync reconciles
      // against the backend-owned user_preferred_locales table (the source of
      // truth). We no longer read GoTrue user_metadata here.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  })
  .then(() => {
    log({ event: 'i18n-init', language: i18n.language })
  })

export { LOCALE_STORAGE_KEY }
export default i18n
